<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">Subject Microscopy {{ title }}</h2>
      <p class="tw-italic tw-text-gray-700">
        View subject microscopy {{ title }}
      </p>
    </b-container>
    <br />

    <b-row>
      <b-col cols="3">
        <b-form-group
          id="fieldset-1"
          label="Bloodslide Code / Subject ID"
          label-for="input-1"
        >
          <b-input-group>
          <b-form-input id="input-1" v-model="search_bloodslide" trim v-on:keydown.enter="updateTable"></b-form-input>
          <b-input-group-append>
            <b-button variant="success" @click="updateTable"><i class="fa fa-search"></i></b-button>
          </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group
          id="fieldset-1"
          label="Study Phase"
          label-for="studyPhase"
        >
          <b-form-select id="studyPhase" v-model="filterPhase" :options="phaseOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group
          id="readercodeid"
          label="Reader Code"
          label-for="readercodeoptions"
        ><b-form-select id="readercodeoptions" v-model="filterReaderCode" :options="readerCodeOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group
          id="bradsaturd"
          label="Status"
          label-for="bat"
        ><b-form-select id="bat" v-model="filterStatus" :options="statusOptions"></b-form-select>
        </b-form-group>
      </b-col>
       
    </b-row>
    <b-row>
      <b-col cols="3">
        <b-form-group
          id="fieldset-1"
          label="Bloodslide Date Taken"
          label-for="input-2"
        >
          <b-input-group>
          <b-form-datepicker id="input-2" v-model="search_bloodslide_date" trim v-on:keydown.enter="updateTable"></b-form-datepicker>
          <b-input-group-append>
            <b-button variant="success" @click="updateTable"><i class="fa fa-search"></i></b-button>
          </b-input-group-append>
          </b-input-group>
        </b-form-group>
        
      </b-col>
      <b-col cols="3">
        <b-form-group
          id="review-required"
          label="Review Status"
          label-for="review-required-select"
        ><b-form-select id="review-required-select" v-model="reviewRequired" :options="reviewRequiredOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col v-if="STUDY != 'mali'" cols="3">
        <b-form-group
          id="urgent-group"
          label="Urgent Status"
          label-for="urgent-select"
        ><b-form-select id="urgent-select" v-model="urgent" :options="urgentOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col v-if="STUDY == 'mali'" cols="3">
        <b-form-group
          id="readable-group"
          label="Bloodslide Readable"
          label-for="readable-select"
        ><b-form-select id="readable-select" v-model="bloodslideReadable" :options="readableOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <span v-if="STUDY != 'mali'">
        <b-col cols="2"></b-col>
        <b-col cols="1" style="text-align: right; position: relative; padding-top: 40px; padding-right: 30px;">
          <b-button variant="primary" @click="printTable" title="Print current page results" style="margin-left: 20px; position: relative; top: -10px;"><i class="fa fa-print"></i></b-button>
        </b-col>
      </span>
    </b-row>

    <b-row v-if="STUDY == 'mali'">
      <!-- <b-col cols="2">
        <b-form-group
          id="visitcodeid"
          label="Visit Code"
          label-for="visitcodeoptions"
        ><b-form-select id="visitcodeoptions" v-model="visit_code" :options="visitCodeOptions"></b-form-select>
        </b-form-group>
      </b-col> -->
      <b-col cols="2">
        <b-form-group
          id="visittypeid"
          label="Visit Type"
          label-for="visittypeoptions"
        ><b-form-select id="visittypeoptions" v-model="visit_type" :options="visitTypeOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group
          id="visitnumid"
          label="Followup Number"
          label-for="visitnumoptions"
        ><b-form-select :disabled="visit_type=='All'" id="visitnumoptions" v-model="visit_num" :options="visitNumOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group
          id="visitstatusid"
          label="Visit Status"
          label-for="visitstatusoptions"
        ><b-form-select id="visitstatusoptions" v-model="visit_status" :options="visitStatusOptions"></b-form-select>
        </b-form-group>
      </b-col>      
      <b-col cols="2">
        <b-form-group
          id="villageeid"
          label="Village"
          label-for="villageoptions"
        ><b-form-select id="villageoptions" v-model="village" :options="villageOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="1"></b-col>
      <b-col cols="1" style="text-align: right; position: relative; padding-top: 40px; padding-right: 30px;">
        <b-button variant="primary" @click="printTable" title="Print current page results" style="margin-left: 20px; position: relative; top: -10px;"><i class="fa fa-print"></i></b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <small>Total Results: {{ totalRows }} <i class="fa fa-download text-success" v-b-modal.report-modal style="margin-left: 10px; cursor: pointer;" title="Download All"></i></small>
      </b-col>
    </b-row>

    <div style="width: 100%; overflow: auto;">
      <b-table
        striped
        hover
        :items="find"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage" :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        ref="resultTable"
        @row-clicked="rowClick"
        :tbody-tr-class="'clickable'"
      >
      <template v-slot:cell(r1_qualitative_result)="data">
        <span v-if="data.item.reviewed.r1 && (data.item.reviewed.r1.status == 'Verified' || data.item.reviewed.r1.user == 'tablet')" style="color: green;">{{ data.item.r1_qualitative_result }}</span>
        <span v-if="data.item.reviewed.r1 && data.item.reviewed.r1.status != 'Verified' && data.item.reviewed.r1.user != 'tablet'" style="color: red;">{{ data.item.r1_qualitative_result }}</span>
        <span v-if="data.item.reviewed.r1 == null">{{ data.item.r1_qualitative_result }}</span>
      </template>
      <template v-slot:cell(r2_qualitative_result)="data">
        <span v-if="data.item.reviewed.r2 && (data.item.reviewed.r2.status == 'Verified' || data.item.reviewed.r2.user == 'tablet')" style="color: green;">{{ data.item.r2_qualitative_result }}</span>
        <span v-if="data.item.reviewed.r2 && data.item.reviewed.r2.status != 'Verified' && data.item.reviewed.r2.user != 'tablet'" style="color: red;">{{ data.item.r2_qualitative_result }}</span>
        <span v-if="data.item.reviewed.r2 == null">{{ data.item.r2_qualitative_result }}</span>
      </template>
      <template v-slot:cell(r3_qualitative_result)="data">
        <span v-if="data.item.reviewed.r3 && (data.item.reviewed.r3.status == 'Verified' || data.item.reviewed.r3.user == 'tablet')" style="color: green;">{{ data.item.r3_qualitative_result }}</span>
        <span v-if="data.item.reviewed.r3 && data.item.reviewed.r3.status != 'Verified' && data.item.reviewed.r3.user != 'tablet'" style="color: red;">{{ data.item.r3_qualitative_result }}</span>
        <span v-if="data.item.reviewed.r3 == null">{{ data.item.r3_qualitative_result }}</span>
      </template>
      </b-table>
    </div>

      <b-row>
        <b-col cols="2">
          <b-form-group
          id="fieldset-2"
          label="Results Per Page"
          label-for="input-2"
        >
          <b-form-select id="input-2" v-model="perPage" :options="perPageOptions"></b-form-select>
        </b-form-group>
        </b-col>
        <b-col class="my-1" cols="9" style="padding-top: 30px;">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal id="report-modal" size="lg" ref="report-modal" title="Request Download" @ok="requestDownload">
        <p>
          Enter your email address below to request your current search to be generated as a full list of cases.  Once the report is ready, a link to download will be emailed to you.
        </p>
        <p>
          <b-form-input v-model="report_email" type="email" placeholder="Enter your email address"></b-form-input>
        </p>
      </b-modal>

        <b-modal id="row-modal" size="xl" ref="row-modal" :tbody-tr-class="'clickable'" :ok-only="true">
         <template v-slot:modal-header>
           <h5>Bloodslide Code: {{ selectedMicroscopy.bloodslide_code }}<br /><span style="padding-left: 0px; font-size: 14px; font-weight: normal;">Collection Date: {{ selectedMicroscopy.bloodslide_taken_date }}</span></h5>
         </template>

         <b-row>
          <b-col cols="3"></b-col>
          <b-col cols="3"><h6>Reading 1</h6></b-col>
          <b-col cols="3"><h6>Reading 2</h6></b-col>
          <b-col cols="3"><h6>Reading 3</h6></b-col>
         </b-row>
         <b-row>
          <b-col cols="3">Reader code</b-col>
          <b-col cols="3">{{ selectedMicroscopy.r1_reader_code }}</b-col>
          <b-col cols="3">{{ selectedMicroscopy.r2_reader_code }}</b-col>
          <b-col v-if="read3requested" cols="3" style="color: red;">Read 3 Requested</b-col>
          <b-col v-else cols="3">{{ selectedMicroscopy.r3_reader_code }}</b-col>
         </b-row>
         <b-row>
          <b-col cols="3">Reading Date/Time</b-col>
          <b-col cols="3">{{ selectedMicroscopy.r1_read_date }} - {{ selectedMicroscopy.r1_read_time }}</b-col>
          <b-col cols="3">{{ selectedMicroscopy.r2_read_date }} - {{ selectedMicroscopy.r2_read_time }}</b-col>
          <b-col v-if="read3requested" cols="3"></b-col>
          <b-col v-else cols="3">{{ selectedMicroscopy.r3_read_date }} - {{ selectedMicroscopy.r3_read_time }}</b-col>
         </b-row>
         <br />
         <!-- Species Identified -->
         <b-row>
          <b-col cols="3">Species Identified</b-col>
          <b-col cols="3">
            <b-row>
            <b-col><label for="r1-species" style="width: 100%;">{{ selectedMicroscopy.r1_species_identified }}</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r1 && (selectedMicroscopy.r1_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r1.species" id="r1-species"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
          <b-col cols="3">
            <b-row>
            <b-col><label for="r2-species" style="width: 100%;">{{ selectedMicroscopy.r2_species_identified }}</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r2 && (selectedMicroscopy.r2_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r2.species" id="r2-species"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
          <b-col cols="3">
            <b-row v-if="selectedMicroscopy.r3_reader_code">
            <b-col><label for="r3-species" style="width: 100%;">{{ selectedMicroscopy.r3_species_identified }}</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r3 && (selectedMicroscopy.r3_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r3.species" id="r3-species"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
         </b-row>
         <!-- END: Species Identified -->
         <!-- Parasite Density Method -->
         <b-row>
          <b-col cols="3">Parasite density method</b-col>
          <b-col cols="3">
            <b-row>
            <b-col><label for="r1-parasite" style="width: 100%;">{{ selectedMicroscopy.r1_parasite_density_method }}</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r1 && (selectedMicroscopy.r1_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r1.parasite" id="r1-parasite"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
          <b-col cols="3">
            <b-row>
            <b-col><label for="r2-parasite" style="width: 100%;">{{ selectedMicroscopy.r2_parasite_density_method }}</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r2 && (selectedMicroscopy.r2_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r2.parasite" id="r2-parasite"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
          <b-col cols="3">
            <b-row v-if="selectedMicroscopy.r3_reader_code">
            <b-col><label for="r3-parasite" style="width: 100%;">{{ selectedMicroscopy.r3_parasite_density_method }}</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r3 && (selectedMicroscopy.r3_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r3.parasite" id="r3-parasite"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
         </b-row>
         <!-- END: Parasite Density Method -->
         <!-- Parasite Density Method - SUB MENU -->
         <b-row>
          <b-col cols="3"></b-col>
          <b-col cols="3">
            <b-row>
            <b-col v-if="selectedMicroscopy.r1_parasite_density_method == 'rbc-thin'"><label for="r1-parasite-sub" style="width: 100%;">{{ selectedMicroscopy.r1_number_parasites_counted_thin }} / pRBCs</label></b-col>
            <b-col v-else><label for="r1-parasite-sub" style="width: 100%;">{{ selectedMicroscopy.r1_number_of_asexual_parasites_thick }} per 40HPF</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r1 && (selectedMicroscopy.r1_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r1.numt" id="r1-parasite-sub"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
          <b-col cols="3">
            <b-row>
            <b-col v-if="selectedMicroscopy.r2_parasite_density_method == 'rbc-thin'"><label for="r2-parasite-sub" style="width: 100%;">{{ selectedMicroscopy.r2_number_parasites_counted_thin }} / pRBCs</label></b-col>
            <b-col v-else><label for="r2-parasite-sub" style="width: 100%;">{{ selectedMicroscopy.r2_number_of_asexual_parasites_thick }} per 40HPF</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r2 && (selectedMicroscopy.r2_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r2.numt" id="r2-parasite-sub"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
          <b-col cols="3">
            <b-row v-if="selectedMicroscopy.r3_reader_code">
            <b-col v-if="selectedMicroscopy.r3_parasite_density_method == 'rbc-thin'"><label for="r3-parasite-sub" style="width: 100%;">{{ selectedMicroscopy.r3_number_parasites_counted_thin }} / pRBCs</label></b-col>
            <b-col v-else><label for="r3-parasite-sub" style="width: 100%;">{{ selectedMicroscopy.r3_number_of_asexual_parasites_thick }} per 40HPF</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r3 && (selectedMicroscopy.r3_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r3.numt" id="r3-parasite-sub"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
         </b-row>
         <!-- END: Parasite Density Method - SUB MENU -->
         <!-- Gametocytes -->
         <b-row>
          <b-col cols="3">Gametocytes</b-col>
          <b-col cols="3">
            <b-row>
            <b-col><label for="r1-gametocytes" style="width: 100%;">{{ selectedMicroscopy.r1_gametocytes_seen }}</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r1 && (selectedMicroscopy.r1_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r1.numg" id="r1-gametocytes"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
          <b-col cols="3">
            <b-row>
            <b-col><label for="r2-gametocytes" style="width: 100%;">{{ selectedMicroscopy.r2_gametocytes_seen }}</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r2 && (selectedMicroscopy.r2_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r2.numg" id="r2-gametocytes"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
          <b-col cols="3">
            <b-row v-if="selectedMicroscopy.r3_reader_code">
            <b-col><label for="r3-gametocytes" style="width: 100%;">{{ selectedMicroscopy.r3_gametocytes_seen }}</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r3 && (selectedMicroscopy.r3_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r3.numg" id="r3-gametocytes"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
         </b-row>
         <!-- END: Gametocytes -->
         <!-- Qualitative -->
         <b-row>
          <b-col cols="3">Qualitative Results</b-col>
          <b-col cols="3">
            <b-row>
            <b-col><label for="r1-qualitative" style="width: 100%;">{{ selectedMicroscopy.r1_qualitative_result }}</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r1 && (selectedMicroscopy.r1_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r1.qualitative" id="r1-qualitative"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
          <b-col cols="3">
            <b-row>
            <b-col><label for="r2-qualitative" style="width: 100%;">{{ selectedMicroscopy.r2_qualitative_result }}</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r2 && (selectedMicroscopy.r2_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r2.qualitative" id="r2-qualitative"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
          <b-col cols="3">
            <b-row v-if="selectedMicroscopy.r3_reader_code">
            <b-col><label for="r3-qualitative" style="width: 100%;">{{ selectedMicroscopy.r3_qualitative_result }}</label></b-col>
            <b-col><b-form-checkbox v-if="!selectedMicroscopy.reviewed.r3 && (selectedMicroscopy.r3_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              v-model="bloodslide_confirm.r3.qualitative" id="r3-qualitative"
            >
            </b-form-checkbox></b-col>
            </b-row>
          </b-col>
         </b-row>
         <!-- END: Qualitative -->
         <br />
         <!-- Reading Result -->
          <b-row>
            <b-col cols="3">Result</b-col>
            <b-col cols="3">
              <b-select v-if="!selectedMicroscopy.reviewed.r1 && (selectedMicroscopy.r1_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')" v-model="bloodslide_confirm.r1.status" :options="read1_statuses">

              </b-select>
              <div v-if="selectedMicroscopy.reviewed.r1">
                {{ selectedMicroscopy.reviewed.r1.status }}
                <div v-if="selectedMicroscopy.reviewed.r1.status == 'Other Error'">
                  {{ selectedMicroscopy.reviewed.r1.comments }}
                </div>
              </div>
               <b-form-textarea v-if="!selectedMicroscopy.reviewed.r1 && (selectedMicroscopy.r1_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required') && bloodslide_confirm.r1.status == 'Other Error'"
                id="r1-other-result"
                v-model="bloodslide_confirm.r1.comments"
                size="sm"
                placeholder="Describe error..."
                style="margin-top: 10px;"
              ></b-form-textarea>
            </b-col>
            <b-col cols="3">
              <b-select v-if="!selectedMicroscopy.reviewed.r2 && (selectedMicroscopy.r2_qc_required == 'Yes' || (selectedMicroscopy.microscopy_status == 'Quality Control Required' && selectedMicroscopy.r1_qualitative_result))" v-model="bloodslide_confirm.r2.status" :options="read_statuses">

              </b-select>
              <div v-if="selectedMicroscopy.reviewed.r2">
                {{ selectedMicroscopy.reviewed.r2.status }}
                <div v-if="selectedMicroscopy.reviewed.r2.status == 'Other Error'">
                  {{ selectedMicroscopy.reviewed.r2.comments }}
                </div>
              </div>
              <b-form-textarea v-if="!selectedMicroscopy.reviewed.r2 && (selectedMicroscopy.r2_qc_required == 'Yes' || (selectedMicroscopy.microscopy_status == 'Quality Control Required' && selectedMicroscopy.r2_qualitative_result)) && bloodslide_confirm.r2.status == 'Other Error'"
                id="r1-other-result"
                v-model="bloodslide_confirm.r2.comments"
                size="sm"
                placeholder="Describe error..."
                style="margin-top: 10px;"
              ></b-form-textarea>
            </b-col>
            <b-col cols="3">
              <b-select v-if="!selectedMicroscopy.reviewed.r3 && (selectedMicroscopy.r3_qc_required == 'Yes' || (selectedMicroscopy.microscopy_status == 'Quality Control Required' && selectedMicroscopy.r3_qualitative_result))" v-model="bloodslide_confirm.r3.status" :options="read_statuses">

              </b-select>
              <div v-if="selectedMicroscopy.reviewed.r3">
                {{ selectedMicroscopy.reviewed.r3.status }}
                <div v-if="selectedMicroscopy.reviewed.r3.status == 'Other Error'">
                  {{ selectedMicroscopy.reviewed.r3.comments }}
                </div>
              </div>
              <b-form-textarea v-if="!selectedMicroscopy.reviewed.r3 && (selectedMicroscopy.r3_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required') && bloodslide_confirm.r3.status == 'Other Error'"
                id="r1-other-result"
                v-model="bloodslide_confirm.r3.comments"
                size="sm"
                placeholder="Describe error..."
                style="margin-top: 10px;"
              ></b-form-textarea>
            </b-col>
          </b-row>
         <!-- END: Reading Result -->
         <!-- Comments -->
         <!-- <b-row>
          <b-col cols="3">Comments</b-col>
          <b-col cols="3">
            <b-form-textarea v-if="!selectedMicroscopy.reviewed.r1 && (selectedMicroscopy.r1_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              id="r1-comments"
              v-model="bloodslide_confirm.r1.comments"
              size="sm"
              placeholder="Comments..."
            ></b-form-textarea>
            <div v-if="selectedMicroscopy.reviewed.r1">
              {{ selectedMicroscopy.reviewed.r1.comments }}
            </div>
          </b-col>
          <b-col cols="3">
            <b-form-textarea v-if="!selectedMicroscopy.reviewed.r2 && (selectedMicroscopy.r2_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              id="r2-comments"
              v-model="bloodslide_confirm.r2.comments"
              size="sm"
              placeholder="Comments..."
            ></b-form-textarea>
            <div v-if="selectedMicroscopy.reviewed.r2">
              {{ selectedMicroscopy.reviewed.r2.comments }}
            </div>
          </b-col>
          <b-col cols="3">
            <b-form-textarea v-if="selectedMicroscopy.r3_reader_code && !selectedMicroscopy.reviewed.r3 && (selectedMicroscopy.r3_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required')"
              id="r3-comments"
              v-model="bloodslide_confirm.r3.comments"
              size="sm"
              placeholder="Comments..."
            ></b-form-textarea>
            <div v-if="selectedMicroscopy.r3_reader_code && selectedMicroscopy.reviewed.r3">
              {{ selectedMicroscopy.reviewed.r3.comments }}
            </div>
          </b-col>
         </b-row> -->
         <!-- END: Comments -->
         <br />
         <!-- Mark as Reviewed -->
         <b-row>
          <b-col cols="3"></b-col>
          <b-col cols="3" v-if="selectedMicroscopy.reviewed.r1">
            <i class="fa fa-check" style="color: green;"></i> {{ selectedMicroscopy.reviewed.r1.timestamp }} by {{ selectedMicroscopy.reviewed.r1.user }}
          </b-col>
          <b-col cols="3" v-if="(selectedMicroscopy.r1_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required') && !selectedMicroscopy.reviewed.r1">
            <b-button variant="success" v-if="bloodslide_confirm.r1.reviewed" @click="submitReview('1')">Mark as Reviewed</b-button>
            <b-button variant="success" disabled v-else>Mark as Reviewed</b-button>
          </b-col>
           <b-col cols="3" v-if="selectedMicroscopy.reviewed.r2">
            <i class="fa fa-check" style="color: green;"></i> {{ selectedMicroscopy.reviewed.r2.timestamp }} by {{ selectedMicroscopy.reviewed.r2.user }}
          </b-col>
          <b-col cols="3" v-if="(selectedMicroscopy.r2_qc_required == 'Yes' || selectedMicroscopy.microscopy_status == 'Quality Control Required') && !selectedMicroscopy.reviewed.r2">
            <b-button variant="success" v-if="bloodslide_confirm.r2.reviewed" @click="submitReview('2')">Mark as Reviewed</b-button>
            <b-button variant="success" disabled v-else>Mark as Reviewed</b-button>
          </b-col>
           <b-col cols="3" v-if="selectedMicroscopy.reviewed.r3">
            <i class="fa fa-check" style="color: green;"></i> {{ selectedMicroscopy.reviewed.r3.timestamp }} by {{ selectedMicroscopy.reviewed.r3.user }}
          </b-col>
          <b-col cols="3" v-if="selectedMicroscopy.r3_qc_required == 'Yes' && !selectedMicroscopy.reviewed.r3">
            <b-button variant="success" v-if="bloodslide_confirm.r3.reviewed && selectedMicroscopy.r3_reader_code" @click="submitReview('3')">Mark as Reviewed</b-button>
            <b-button variant="success" disabled v-if="!bloodslide_confirm.r3.reviewed && selectedMicroscopy.r3_reader_code">Mark as Reviewed</b-button>
          </b-col>
         </b-row>
         <!-- END: Mark as Reviewed -->
        
      </b-modal>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
  mixins: [
    // BaseTemplate,
    DashboardBaseTemplate,
  ],
  components: {},
  props: {},
  data: function() {
    return {
      sortBy: 'bloodslide_taken_date',
      sortDesc: true,
      cases: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      title: "",
      urgent: 'All',
      bloodslideReadable: 'All',
      report_email: '',
      urgentOptions: [
        'All',
        'Urgent',
        'Not Urgent'
      ],
      readableOptions: [
        'All',
        'Readable',
        'Unreadable'
      ],
      search_bloodslide: null,
      search_bloodslide_date: null,
      visit_code: 'All',
      village: 'All',
      reviewRequired: 'All',
      reviewRequiredOptions: [
        'All',
        'Review Required'
      ],
      perPageOptions: [
        10,
        15,
        20,
        25,
        50
      ],
      statusOptions: [
        'All',
        'Awaiting First Read - Received at the Lab',
        'Awaiting First Read - Not Recevied at the Lab',
        'Awaiting Second Read',
        'Awaiting Third Read',
        'Complete'
      ],
      filterPhase: 'Cohort 2',
      phaseOptions: [
        'All',
        'Baseline',
        'Cohort 1',
        'Cohort 2'
      ], 
      filterStatus: 'All',
      filterReaderCode: 'All',
      readerCodeOptions: [
        'All'
      ],
      visitCodeOptions: [
        'All'
      ],
      visit_type: 'All',
      visitTypeOptions: [
        'All',
        'Followup Monthly',
        'Followup Bi-Weekly',
        'Unscheduled'
      ],
      visit_num: 'All',
      allNumOptions: [
        'All',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
      ],
      monthlyNumOptions: [
        'All',
        '01',
        '02',
        '04',
        '06',
        '08',
        '10',
        '12',
        '14',
        '16',
        '18',
        '20',
        '22',
        '24',
        '26',
        '28',
        '30',
        '32',
        '34',
        '36',
        '38',
        '40',
        '42',
        '44',
        '46',
        '48'
      ],
      biweeklyNumOptions: [
        'All',
        '03',
        '05',
        '07',
        '09',
        '11',
        '13',
        '15',
        '17',
        '19',
        '21',
        '23',
        '25',
        '27',
        '29',
        '31',
        '33',
        '35',
        '37',
        '39',
        '41',
        '43',
        '45',
        '47'
      ],
      visitNumOptions : [],
      visit_status: 'All',
      visitStatusOptions: [
        {text:'All', value: 'All'},
        {text:'Complete', value: 'COMP'},
        // {text:'Incomplete', value: 'INCOMP'},
        {text:'LTFU', value: 'LTFU'}
      ],
      villageOptions: [
        'All'
      ],
      selectedMicroscopy: {
        bloodslide_code: '',
        reviewed: ''
      },
      read1_statuses: [
        'Verified',
        'Other Error'
      ],
      read_statuses: [
        'Verified',
        'Discordant Quality',
        'Discordant Quantity',
        'Same Reader Error',
        'Other Error'
      ],
      bloodslide_confirm: {
        r1: {
          species: false,
          parasite: false,
          numt: false,
          numg: false,
          qualitative: false,
          comments: '',
          reviewed: false,
          status: '',
          other_status: ''
        },
        r2: {
          species: false,
          parasite: false,
          numt: false,
          numg: false,
          qualitative: false,
          comments: '',
          reviewed: false,
          status: '',
          other_status: ''
        },
        r3: {
          species: false,
          parasite: false,
          numt: false,
          numg: false,
          qualitative: false,
          comments: '',
          reviewed: false,
          status: '',
          other_status: ''
        }
      }
    };
  },
  computed: {
    read3requested() {
      if(this.STUDY == 'kenya'){
        if(this.selectedMicroscopy.read_3_requested == 'Yes'){
          return true;
        } else {
          return false;
        }
      }
      return false;
    }
  },
  watch: {
    // currentPage: function(new_page){
    //   this.find();
    // },
    // perPage: function(){
    //   this.find();
    // },
    // sortDesc: function(){
    //   this.find();
    // },
    // sortBy: function(){
    //   this.find();
    // },
    filterStatus: function(){
      this.updateTable();
    },
    filterReaderCode: function(){
      this.updateTable();
    },
    urgent: function(){
      this.updateTable();
    },
    bloodslideReadable: function(){
      this.updateTable();
    },
    reviewRequired: function(){
      this.updateTable();
    },
    filterPhase: function(){
      this.updateTable();
    },
    visit_code: function(){
      this.updateTable();
    },
    village: function(){
      this.updateTable();
    },
    // VISIT CODE SUB-FILTERS
    visit_type: function(){
      if(this.visit_type == 'Followup Monthly'){
        this.visitNumOptions = this.monthlyNumOptions;
      } else if (this.visit_type == 'Followup Bi-Weekly') {
        this.visitNumOptions = this.biweeklyNumOptions;
      } else if (this.visit_type == 'Unscheduled') {
        this.visitNumOptions = this.allNumOptions;
      } else {
        this.visitNumOptions = this.allNumOptions;
      }

      this.visit_num = 'All';
      // this.updateTable();
    },
    visit_num: function(val){
      if (val != 'All'){
        this.updateTable();
      }
    },
    visit_status: function(){
      this.updateTable();
    },
    bloodslide_confirm: {
      deep: true,

      handler(){
        for(let read_code in this.bloodslide_confirm){
          let read = this.bloodslide_confirm[read_code];
          if(read.species && read.parasite && read.numt && read.numg && read.qualitative && read.status != '' && read.status != undefined){
            console.log(read.status);
            read.reviewed = true;
          }
          else{
            read.reviewed = false;
          }
        }
      }
      
    }
  },
  created: function() {
    this.setUpFields(this.$route.params.view);

    if(this.STUDY == 'mali'){
      this.phaseOptions = ['All', 'Baseline', 'Intervention'];
      this.visitNumOptions = this.allNumOptions;
    }
  },
  mounted: function() {
    let that = this;
    if(this.STUDY == 'mali'){
      this.filterPhase = 'Baseline';
      this.statusOptions = [
        'All',
        'Awaiting First Read',
        'Awaiting Second Read',
        'Awaiting Third Read',
        'Complete'
      ]
    }
    // load the available reader codes
    HTTP.get("/kenya/microscopy-case/reader_codes")
        .then((response) => {
          _.each(response.data.codes, function(item){
            that.readerCodeOptions.push(item);
          });
        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        })

    // load the visit code and village drop-down options
    HTTP.get("/kenya/microscopy-case/drop-down-options")
      .then((response) => {
        _.each(response.data.villages, function(item){
          that.villageOptions.push(item);
        });
        _.each(response.data.visit_codes, function(item){
          that.visitCodeOptions.push(item);
        });
      })
      .catch((error) => {
        HandleErrors.HandleErrors(error);
      })
  },
  methods: {
    requestDownload: function(){
      let that = this;
      let params = {
        email: that.report_email
      }

      if(that.search_bloodslide && that.search_bloodslide != ''){
        params.search_bloodslide = that.search_bloodslide;
      }
      if(that.filterStatus != 'All'){
        params.status = that.filterStatus;
      }
      if(that.filterReaderCode != 'All'){
        params.reader_code = that.filterReaderCode;
      }
      if(that.urgent != 'All'){
        params.urgent = that.urgent;
      }
      if(that.bloodslideReadable != 'All'){
        params.bloodslideReadable = that.bloodslideReadable;
      }
      if(that.reviewRequired != 'All'){
        params.review_required = that.reviewRequired;
      }
      if(that.filterPhase != 'All'){
        params.study_phase = that.filterPhase;
      }
      
      // if(that.visit_code && that.visit_code != ''){
      //   params.visit_code = that.visit_code;
      // }
      // if(that.village && that.village != ''){
      //   params.village = that.village;
      // }
      if(that.visit_code != 'All'){
        params.visit_code = that.visit_code;
      }
      if(that.village != 'All'){
        params.village = that.village;
      }
      // VISIT CODE SUB-FILTERS
      if(that.visit_type != 'All'){
        params.visit_type = that.visit_type;
      }
      if(that.visit_num != 'All'){
        params.visit_num = that.visit_num;
      }
      if(that.visit_status != 'All'){
        params.visit_status = that.visit_status;
      }

      HTTP.get("/kenya/microscopy-case-download/", {
        params: params
      })
        .then((response) => {
          alert("You will receive a link to download the report shortly.")
        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
    submitReview: function(read_number){
      let read = this.bloodslide_confirm['r'+read_number];
      let that = this;
     
      const fd = new FormData();
      fd.append('comments', read.comments);
      fd.append('read_number', read_number);
      fd.append('subject_microscopy_id', this.selectedMicroscopy.id);
      fd.append('status', read.status);
      HTTP.post('/kenya/microscopy-case/submit-review', fd).then((response) => {
        console.log(response);
        that.selectedMicroscopy.reviewed['r'+read_number] = {
          user: response.data.reviewed_by,
          timestamp: response.data.reviewed_on,
          comments: response.data.comments,
          status: response.data.status
        }
      }).catch(error => {
        HandleErrors.HandleErrors(error);
      });
    },
    resetBloodslideReview: function(){
      this.bloodslide_confirm = {
        r1: {
          species: false,
          parasite: false,
          numt: false,
          numg: false,
          qualitative: false,
          comments: '',
          reviewed: false
        },
        r2: {
          species: false,
          parasite: false,
          numt: false,
          numg: false,
          qualitative: false,
          comments: '',
          reviewed: false
        },
        r3: {
          species: false,
          parasite: false,
          numt: false,
          numg: false,
          qualitative: false,
          comments: '',
          reviewed: false
        }
      }
    },
    updateTable: function(){
      this.$refs.resultTable.refresh();
    },
    printTable: function(){
      let table_id = this.$refs.resultTable.localId_;
      var divToPrint=document.getElementById(table_id);
      var newWin = window.open("");
      var html_to_print = divToPrint.outerHTML.replaceAll(' (Click to clear sorting)', '').replaceAll(' (Click to sort Ascending)', '');
      var all_html = '<html><head>\
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" integrity="undefined" crossorigin="anonymous">\
      <body>\
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" integrity="undefined" crossorigin="anonymous">\
      '+html_to_print+'<style>\
      </style>\
      </body></html>';
      // get the stylesheet
      newWin.document.write(all_html);
      newWin.document.close();
      var myDelay = setInterval(checkReadyState, 10);
      function checkReadyState() {
          if (newWin.document.readyState == "complete") {
              clearInterval(myDelay);
              newWin.focus(); // necessary for IE >= 10

              newWin.print();
              newWin.close();
          }
      }
    },
    rowClick: function(item){
      let that = this;
      that.resetBloodslideReview();
      that.selectedMicroscopy = item;
      console.log(item);
      that.$refs['row-modal'].show();
    },
    find: function(ctx) {
      let that = this;
      let params = {
        current_page: ctx.currentPage,
        per_page: ctx.perPage,
        sort_by: ctx.sortBy,
        sort_desc: ctx.sortDesc
      }

      if(that.search_bloodslide && that.search_bloodslide != ''){
        params.search_bloodslide = that.search_bloodslide;
      }
      if(that.search_bloodslide_date && that.search_bloodslide_date != ''){
        params.search_bloodslide_date = that.search_bloodslide_date;
      }
      if(that.filterStatus != 'All'){
        params.status = that.filterStatus;
      }
      if(that.filterReaderCode != 'All'){
        params.reader_code = that.filterReaderCode;
      }
      if(that.urgent != 'All'){
        params.urgent = that.urgent;
      }
      if(that.bloodslideReadable != 'All'){
        params.bloodslideReadable = that.bloodslideReadable;
      }
      if(that.reviewRequired != 'All'){
        params.review_required = that.reviewRequired;
      }

      if(that.filterPhase != 'All'){
        params.study_phase = that.filterPhase;
      }

      // if(that.visit_code && that.visit_code != ''){
      //   params.visit_code = that.visit_code;
      // }
      // if(that.village && that.village != ''){
      //   params.village = that.village;
      // }
      if(that.visit_code != 'All'){
        params.visit_code = that.visit_code;
      }
      if(that.village != 'All'){
        params.village = that.village;
      }
      // VISIT CODE SUB-FILTERS
      if(that.visit_type != 'All'){
        params.visit_type = that.visit_type;
      }
      if(that.visit_num != 'All'){
        params.visit_num = that.visit_num;
      }
      if(that.visit_status != 'All'){
        params.visit_status = that.visit_status;
      }

      return HTTP.get("/kenya/microscopy-case/", {
        params: params
      })
        .then((response) => {
          that.cases = response.data.cases;
          that.totalRows = response.data.totalRows;
          return response.data.cases;
        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
    setUpFields: function(view) {
      if (view == "details") {
        this.title = "Details";
        this.fields = [
          { key: "bloodslide_code", label: "Bloodslide Code" },
          { key: "collection_date", label: "Collection Date" },

          { key: "r1_qualitative_result", label: "MCR1Result" },
          { key: "r2_qualitative_result", label: "MCR2Result" },
          { key: "r3_qualitative_result", label: "MCR3Result" },
          { key: "finalmcrresult", label: "Final MCR Result" },

          { key: "r1_species_identified", label: "Species ID 1" },
          { key: "r2_species_identified", label: "Species ID 2" },
          { key: "r3_species_identified", label: "Species ID 3" },
          { key: "finalspeciesid", label: "Final Species ID" },

          { key: "r1_parasite_density", label: "Parasite Density 1" },
          { key: "r2_parasite_density", label: "Parasite Density 2" },
          { key: "r3_parasite_density", label: "Parasite Density 3" },
          { key: "finalparadensity", label: "Final Parasite Density" },

          { key: "r1_gametocytes_seen", label: "Gametocyte 1" },
          { key: "r1_gametocytes_seen", label: "Gametocyte 2" },
          { key: "r1_gametocytes_seen", label: "Gametocyte 3" },
        ];
      } else {
        this.title = "Summary";
        this.fields = [
          { key: "bloodslide_code", label: "Bloodslide Code", sortable: true },
          { key: "subject_id", label: "Subject ID", sortable: true},
          { key: "bloodslide_taken_date", label: "Date", sortable: true},
          { key: "r1_qualitative_result", label: "Read 1", sortable: true},
          { key: "r2_qualitative_result", label: "Read 2", sortable: true},
          { key: "r3_qualitative_result", label: "Read 3", sortable: true},
          { key: "finalmcrresult", label: "Final MCR Result", sortable: true },
          { key: "finalspeciesid", label: "Final Species ID", sortable: true },
          { key: "finalparadensity", label: "Final Parasite Density", sortable: true },
        ];
        if(this.STUDY == 'mali'){
          this.fields.splice(3, 0, { key: "visit_code", label: "Visit Code", sortable: true }); // insert into index 3
          this.fields.push({ key: "can_slide_be_read", label: "Bloodslide Readable", sortable: true });
        }
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.setUpFields(to.params.view);
    next();
  }
};
</script>

<style scoped>
.clickable{
  cursor: pointer;
}
</style>
